"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _ClientContext = _interopRequireWildcard(require("./ClientContext"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var SanityClientContextWrapper = function SanityClientContextWrapper(_ref) {
  var children = _ref.children,
    clientConfig = _ref.clientConfig;
  var _useState = (0, _react.useState)((0, _extends2.default)({}, (0, _ClientContext.makeInitialContext)(clientConfig))),
    state = _useState[0],
    setState = _useState[1];
  return /*#__PURE__*/_react.default.createElement(_ClientContext.default.Provider, {
    value: state
  }, children);
};
var _default = exports.default = function _default(_ref2, pluginOptions) {
  var element = _ref2.element;
  return /*#__PURE__*/_react.default.createElement(SanityClientContextWrapper, {
    clientConfig: pluginOptions.clientConfig
  }, element);
};